<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  }),
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.updateDeviceType)
    console.log('deviceType', this.isMobile())
    this.updateDeviceType()
  },
  methods: {
    isMobile() {
      if (
        window.navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return true // 移动端
      } else {
        return false // PC端
      }
    },
    updateDeviceType() {
      // 判断设备类型
      const deviceType =
        this.isMobile() || window.innerWidth <= 768 ? 'mobile' : 'pc'
      console.log(deviceType, '132456')
      this.$store.dispatch('updateDeviceType', deviceType)
      const path =
        this.isMobile() || window.innerWidth <= 768
          ? '/mobile/home'
          : '/pc/home'
      console.log(path, 'pathApp')
      sessionStorage.setItem('currentPath', path)
    }
  }
}
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
  // transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  font-family: PingFangSC-Regular, PingFang SC;
}
</style>
